<div
  class="bn-case-card"
  [id]="'bn-case-card-' + case().id"
  [class.bn-case-card--expanded]="expanded()"
>
  <button
    type="button"
    class="bn-case-card__row flex items-center gap-3 w-full text-left"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="panelId()"
    (click)="toggle()"
  >
    <span class="bn-case-card__chevron" aria-hidden="true">
      <i
        class="pi"
        [class.pi-chevron-down]="!expanded()"
        [class.pi-chevron-up]="expanded()"
      ></i>
    </span>
    <span class="bn-case-card__heading flex flex-col flex-1">
      <span class="bn-case-card__title">{{ case().title }}</span>
      @if (case().createdAt; as createdAt) {
        <span class="bn-case-card__created">
          Created {{ createdAt | date: 'MMM d, y' : 'UTC' }}
        </span>
      }
      @if (case().status === 'closed') {
        @if (case().closedAt; as closedAt) {
          <span class="bn-case-card__created">
            Closed {{ closedAt | date: 'MMM d, y' : 'UTC' }}
          </span>
        }
      }
    </span>
    @if (showStatusBadge()) {
      <bn-case-status-badge
        [status]="case().status"
        [displayLabel]="store.statusLabel(case().status)"
      />
    }
  </button>

  @if (expanded()) {
    <div class="bn-case-card__panel" [id]="panelId()">
      <bn-case-detail
        [caseId]="case().id"
        [store]="store"
        (collapse)="collapse()"
      />
    </div>
  }
</div>
